import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Icon } from '../ui/Icon';
import { ThemeToggle } from './ThemeToggle';
import { GlobalSearch } from './GlobalSearch';

const TITLES: Record<string, string> = {
  '/overview': 'Overview',
  '/orders': 'Shipments',
  '/profile': 'Profile',
  '/wallet': 'Wallet',
  '/contacts': 'Contacts',
  '/api-tokens': 'API tokens',
  '/internal-shipments': 'Internal shipments',
  '/internal-shipments/new': 'New internal shipment',
  '/address-validation': 'Address validation',
  '/ai-shipment': 'AI shipment',
};

const titleForPath = (path: string): string => {
  if (TITLES[path]) return TITLES[path];
  if (path.startsWith('/orders/')) return 'Shipment detail';
  if (path.startsWith('/internal-shipments/')) return 'Internal shipment';
  return 'Dashboard';
};

export const DashTopbar: React.FC<{ onMenuToggle?: () => void; mobileOpen?: boolean }> = ({ onMenuToggle, mobileOpen = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const initials = React.useMemo(() => {
    const u = user as { firstName?: string; lastName?: string; first_name?: string; last_name?: string } | null;
    if (!u) return 'U';
    const f = u.firstName?.[0] ?? u.first_name?.[0] ?? '';
    const l = u.lastName?.[0] ?? u.last_name?.[0] ?? '';
    return (f + l || 'U').toUpperCase();
  }, [user]);

  return (
    <header className="dash-top">
      <div className="dash-top-left">
        <button
          type="button"
          className="btn btn-ghost btn-sm dash-menu-btn"
          aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={mobileOpen}
          onClick={onMenuToggle}
        >
          <Icon name={mobileOpen ? 'x' : 'menu'} size={18} />
        </button>
        <div className="dash-crumb">
          <Icon name="home" size={13} />
          <span>/</span>
          <span style={{ color: 'var(--ink)', fontWeight: 500 }}>
            {titleForPath(location.pathname)}
          </span>
        </div>
      </div>
      <div className="dash-top-right">
        <GlobalSearch />
        <ThemeToggle />
        <button
          type="button"
          className="btn btn-ghost btn-sm"
          title="Notifications"
          aria-label="Notifications"
        >
          <Icon name="bell" size={16} />
        </button>
        <button
          type="button"
          className="btn btn-ghost btn-sm"
          title="Help"
          aria-label="Help"
          onClick={() => navigate('/faq')}
        >
          <Icon name="help" size={16} />
        </button>
        <button
          type="button"
          className="dash-avatar"
          title="Profile"
          aria-label="Profile"
          onClick={() => navigate('/profile')}
        >
          {initials}
        </button>
      </div>
    </header>
  );
};

export default DashTopbar;
